const APPLE_OAUTH_BASE = "https://appleid.apple.com/auth/authorize";

function buildAppleOAuthUrl(params: { state?: string }): string {
  const searchParams = new URLSearchParams({
    client_id: import.meta.env.VITE_APPLE_CLIENT_ID, // usually your Services ID for web
    redirect_uri: import.meta.env.VITE_APPLE_REDIRECT_URI,
    response_type: "code",
    response_mode: "query"
  });

  if (params.state) {
    searchParams.set("state", params.state);
  }

  return `${APPLE_OAUTH_BASE}?${searchParams.toString()}`;
}

/**
 * Redirect the user to Apple OAuth for sign-in.
 */
export function startAppleSignIn(): void {
  const url = buildAppleOAuthUrl({
    state: "apple_signin"
  });

  window.location.href = url;
}
